const value = (key: string) => process.env["REACT_APP_" + key];

export default class Config {
  public static mixpanelToken = () => value("MIXPANEL_TOKEN");
  public static shouldTrackAnalytics = () => Config.isProd();

  public static isCypress = () => value("CYPRESS") === "true";
  public static isLocal = () => (Config.envName() === "local") && (!Config.isCypress());
  public static isDev = () => (Config.envName() === "staging") || Config.isCypress();
  public static isPreProd = () => Config.envName() === "testing";
  public static isProd = () => Config.envName() === "production";

  public static envName = () => value("ENV")

  public static firebaseFunctionsUrl = () => {
    if (Config.isCypress()) {
      return Config.cloudFunctionsUrl()
    }

    return {
      "local": Config.emulatorFunctionsUrl(),
      "staging": Config.cloudFunctionsUrl(),
      "testing": Config.cloudFunctionsUrl(),
      "production": Config.cloudFunctionsUrl()
    }[Config.envName() as string]
  }

  public static firebaseApiKey = () => value("FIREBASE_API_KEY");
  public static firebaseAuthDomain = () => value("FIREBASE_AUTH_DOMAIN");
  public static firebaseFirestoreEmulatorHost = () => value("FIREBASE_EMULATOR_FIRESTORE_HOST")
  public static firebaseRealtimeDbUrl = () => {
    return Config.isLocal()
        ? value("FIREBASE_EMULATOR_REALTIME_DB_URL")
        : value("FIREBASE_REALTIME_DB_URL")
  }

  public static firebaseProjectId = () => value("FIREBASE_PROJECT_ID");
  public static firebaseStorageBucket = () => value("FIREBASE_STORAGE_BUCKET");
  public static firebaseMessagingSenderId = () =>
    value("FIREBASE_MESSAGING_SENDER_ID");

  public static defaulApplicationPdfUrl = () => value("DEFAULT_APP_PDF_URL");

  public static ravenUrl = () => value("RAVEN_URL");

  public static cloudFunctionsUrl = () => value("FIREBASE_FUNCTIONS_URL");
  public static emulatorFunctionsUrl = () => value("FIREBASE_EMULATOR_FUNCTIONS_URL");

  public static plaidKey = () => value("PLAID_KEY");

  public static googlePlacesKey = () => value("PGOOGLE_PLACES_KEY");

  public static authorizeKey = () => value("AUTHORIZE_KEY");
  public static authorizeApiID = () => value("AUTHORIZE_API_ID");
  public static authorizeLibURL = () => value("AUTHORIZE_URL");

  public static domain = () => window.location.host

  public static googleAnalyticsTrackingCode = () => value("ANALYTICS_TRACKING_CODE");
  public static googleTagManagerId = () => value("TAG_MANAGER_ID");
  public static facebookPixel = () => value("FACEBOOK_PIXEL_CODE");
}



// WEBPACK FOOTER //
// ./src/services/Config/Config.ts